import { render, staticRenderFns } from "./GalleryCard.vue?vue&type=template&id=b27d5894&scoped=true"
import script from "./GalleryCard.vue?vue&type=script&lang=js"
export * from "./GalleryCard.vue?vue&type=script&lang=js"
import style0 from "./GalleryCard.vue?vue&type=style&index=0&id=b27d5894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27d5894",
  null
  
)

export default component.exports